import { HttpClient } from '../HttpClient';
/**
 * * Get List of Departments per Company
 */
export const GetCompanyDepartments = async ({ PageNumber = 1, RowsPerPage = 10, CompanyId, SearchString, SortColumn = 'departmentName', SortOrder = "asc" }) => {
  try {
    const { data } = await HttpClient.get(`/api/companies/${CompanyId}/departments`, {
      params: {
        ...(SearchString ? { SearchString: SearchString } : {}),
        PageNumber,
        RowsPerPage,
        SortColumn,
        SortOrder
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
